import { IQueryTypeFragments } from '../../QueryFragments';
import { QueryType } from '../Default';

const skuBenefitStatementFragment = `
    on ${QueryType.skus} {
        benefit {
            statement
        }
    }
`;

export const skuBenefitStatementFragments = (): IQueryTypeFragments => {
    return {
        [QueryType.skus]: skuBenefitStatementFragment
    };
};
